<!-- 评价列表 -->
<template>
  <div>
    <a-modal v-model:visible="visible" width="70%" title="评价列表" :footer="null" :zIndex="1000">
      <div>
        <view class="button">
          <a-button type="primary" @click="add">添加评价</a-button>
        </view>
        <a-table
          class="table"
          :pagination="pagination"
          :rowKey="(record, index) => index"
          :columns="columns"
          :data-source="tableData"
          @change="onChangePage"
          :scroll="{ x: `calc(100% - 40px)`, y: `calc(100vh - ${sHeight}px )` }"
          :transformCellText="({ text }) => text ?? '--'"
        >
          <template #daEvaluationScore="{ record }">
            <span>{{ record.daEvaluationScore || 0 }}</span>
          </template>
        </a-table>
      </div>
    </a-modal>
    <a-modal :zIndex="1001" v-model:visible="addVisible" title="添加评价" width="520px">
      <div class="formClass">
        <a-form
          ref="formRef"
          :model="formState"
          name="basic"
          :label-col="labelCol"
          autocomplete="off"
          labelAlign="left"
          :noStyle="true"
        >
          <a-form-item label="医生" name="doctorName">
            <span>{{ formState.doctorName }}</span>
          </a-form-item>
          <a-form-item
            label="分数"
            name="score"
            :rules="[{ required: true, message: '请输入分数' }]"
          >
            <a-input-number
              v-model:value="formState.score"
              style="width: 242px"
              :min="0"
              :max="100"
              :precision="0"
              placeholder="请输入0-100的整数"
            />
          </a-form-item>
        </a-form>
      </div>
      <template #footer>
        <a-button key="back" @click="handleCancel">取消</a-button>
        <a-button
          key="submit"
          type="primary"
          html-type="submit"
          :loading="confirmLoading"
          @click="handleOk"
        >
          确定
        </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script setup>
import { ref, defineExpose, reactive } from 'vue'
import { columns, paginationConfig } from './config'
import { getEvaluationList, addEvaluation } from '@/api/UserPool'
const formRef = ref()
const sHeight = ref(450)
const visible = ref(false)
const addVisible = ref(false)
const pagination = reactive({ ...paginationConfig })
const labelCol = reactive({
  style: { width: '60px', textAlign: 'right' }
})
const confirmLoading = ref(false)
const formState = reactive({
  doctorName: '',
  score: null
})
let info = reactive({})
const tableData = ref([])

const openList = row => {
  const { doctorName = '' } = row
  formState.doctorName = doctorName
  info = { ...row }
  getList()
  visible.value = true
}
const getList = type => {
  const { ucDoctorId = null } = info
  if (type === 'init') {
    pagination.current = 1
  }
  const params = {
    ucDoctorId,
    evaluationRecordType: 2,
    pageNo: pagination.current,
    pageSize: pagination.pageSize
  }
  getEvaluationList(params).then(res => {
    const { list = [], totalCount } = res
    tableData.value = list
    pagination.total = totalCount
    pagination.showTotal = () => `共${totalCount}条`
  })
}
const add = () => {
  addVisible.value = true
  formState.score = null
}
const handleCancel = () => {
  addVisible.value = false
}
const handleOk = () => {
  formRef.value.validate().then(() => {
    confirmLoading.value = true
    const { score = null } = formState
    const { ucDoctorId = null } = info
    const params = {
      ucDoctorId,
      score
    }
    addEvaluation(params)
      .then(() => {
        addVisible.value = false
        getList('init')
      })
      .finally(() => {
        confirmLoading.value = false
      })
  })
}
// 改变当前页
const onChangePage = page => {
  pagination.current = page.current
  pagination.pageSize = page.pageSize
  getList()
}
defineExpose({ openList })
</script>
<style scoped lang="scss">
.formClass {
  padding: 0px 28px 5px 28px;
  ::v-deep(.ant-form-item) {
    margin-bottom: 16px;
  }
  ::v-deep(.ant-input-number) {
    border-radius: 6px;
  }
  ::v-deep(.ant-input-number-handler-wrap) {
    border-radius: 0 6px 6px 0;
  }
  ::v-deep(.ant-form-item:last-child) {
    margin-bottom: 0px;
  }
}
.button {
  display: flex;
  width: 100%;
  text-align: right;
  padding-bottom: 8px;
  height: auto;
  justify-content: flex-end;
}
</style>
